import { RootState } from 'bootstrap';
import { useSelector } from 'react-redux';
import { FederatedModules } from 'types';
const Config = require('Config');

// export type Products = 'Fuel' | 'Freight' | 'Factoring' | 'Credit' | 'LoadManagement';

const usePardotParamBuilder = (product?: FederatedModules) => {
  const { pardotCampaigns = {} } = Config;
  const user = useSelector((state: RootState) => state.app.user);
  const queryInfo = {
    ...(Reflect.get(pardotCampaigns, product) ?? {}),
    first_name: user?.firstname ?? '',
    last_name: user?.lastname ?? '',
    email: user?.email ?? '',
    phone: user?.phone ?? '',
    company: user?.company,
  };
  return new URLSearchParams(queryInfo).toString();
};

export const usePardotUrl: (args: { product?: FederatedModules; url?: string }) => string = ({ product, url }) =>
  `${url}?${usePardotParamBuilder(product)}`;
